(() => { if (window.BEAEPAGEJS === undefined) {
            window.BEAEPAGEJS = [];
          }

          if(window.beaePageSetting == undefined) {
            window.beaePageSetting = {};
          }
          
          window.beaePageSetting.pageId = "6992a69e4fdc805a57009727";
              window.beaePageSetting.pageTitle = "Book Your Pool Service"; 
              window.beaePageSetting.pageType = "page";

          let js_2SNO48VL = () => { let BeaeUseHooks = {};
      try {
        let argid = 'beae-5yfv0hyusection-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-5yfv0hyu',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-5yfv0hyu');
        args.el = args.els[0];
        ((t) => { var o;if((o=t.el.querySelector(".beae-grid-system"))==null||o.addEventListener("scroll",a=>{var r,l;let n=a.target;if(!n.classList.contains("beae-grid-carousel"))return;let s=Math.round((n.scrollLeft+n.querySelector(".beae-grid-carousel__snaps").offsetLeft)/(n.offsetWidth*.8))+1;(r=t.el.querySelector(".beae-grid-carousel__pagination div.active"))==null||r.classList.remove("active"),(l=t.el.querySelector('.beae-grid-carousel__pagination div[data-index="'+s+'"]'))==null||l.classList.add("active")}),t.mode.value=="live"){const a=t.el.querySelector('.beae-section-background-video[data-device="desktop"]'),n=t.el.querySelector('.beae-section-background-video[data-device="mobile"]'),s=[];window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection&&(window.innerWidth>=768?a&&window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a)&&s.push("desktop"):n&&window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,n)&&s.push("mobile")),(a||n)&&window.addEventListener("resize",()=>{if(window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection){if(!s.includes("desktop")&&window.innerWidth>=768&&a){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a);r&&(a.innerHTML=r.html,s.push("desktop"))}if(!s.includes("mobile")&&window.innerWidth<768&&n){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,n);r&&(n.innerHTML=r.html,s.push("mobile"))}}})}t.el.querySelectorAll(".beae-text-highlight").forEach(a=>{new IntersectionObserver((s,r)=>{s.forEach(l=>{l.isIntersecting&&(l.target.querySelectorAll("path, line").forEach(c=>{c.style.strokeDasharray=parseFloat(c.getAttribute("data-dash-ratio")*l.target.offsetWidth*2)+"px, 999999px"}),r.unobserve(l.target))})},{root:document,rootMargin:"0px 0px -40%"}).observe(a)}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-5yfv0hyu: ', ex)
      };
    

      try {
        let argid = 'beae-uni6uffyblock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-uni6uffy',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-uni6uffy');
        args.el = args.els[0];
        ((O) => { var z;let H=(z=O.el)==null?void 0:z.querySelectorAll(".beae-x-text a");H==null||H.forEach(I=>{let E=I==null?void 0:I.getAttribute("href");I&&O.mode.value!=="builder"&&(E!=null&&E.includes("#"))&&I.addEventListener("click",A=>{let D=document.querySelector(E+","+(E==null?void 0:E.replace("#",".")));if(D)return D.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),A.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-uni6uffy: ', ex)
      };
    

      try {
        let argid = 'beae-1k189xhusection-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-1k189xhu',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-1k189xhu');
        args.el = args.els[0];
        ((t) => { var o;if((o=t.el.querySelector(".beae-grid-system"))==null||o.addEventListener("scroll",a=>{var r,l;let n=a.target;if(!n.classList.contains("beae-grid-carousel"))return;let s=Math.round((n.scrollLeft+n.querySelector(".beae-grid-carousel__snaps").offsetLeft)/(n.offsetWidth*.8))+1;(r=t.el.querySelector(".beae-grid-carousel__pagination div.active"))==null||r.classList.remove("active"),(l=t.el.querySelector('.beae-grid-carousel__pagination div[data-index="'+s+'"]'))==null||l.classList.add("active")}),t.mode.value=="live"){const a=t.el.querySelector('.beae-section-background-video[data-device="desktop"]'),n=t.el.querySelector('.beae-section-background-video[data-device="mobile"]'),s=[];window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection&&(window.innerWidth>=768?a&&window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a)&&s.push("desktop"):n&&window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,n)&&s.push("mobile")),(a||n)&&window.addEventListener("resize",()=>{if(window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection){if(!s.includes("desktop")&&window.innerWidth>=768&&a){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a);r&&(a.innerHTML=r.html,s.push("desktop"))}if(!s.includes("mobile")&&window.innerWidth<768&&n){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,n);r&&(n.innerHTML=r.html,s.push("mobile"))}}})}t.el.querySelectorAll(".beae-text-highlight").forEach(a=>{new IntersectionObserver((s,r)=>{s.forEach(l=>{l.isIntersecting&&(l.target.querySelectorAll("path, line").forEach(c=>{c.style.strokeDasharray=parseFloat(c.getAttribute("data-dash-ratio")*l.target.offsetWidth*2)+"px, 999999px"}),r.unobserve(l.target))})},{root:document,rootMargin:"0px 0px -40%"}).observe(a)}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-1k189xhu: ', ex)
      };
    

      try {
        let argid = 'beae-k7k30j4zblock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-k7k30j4z',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-k7k30j4z');
        args.el = args.els[0];
        ((O) => { var z;let H=(z=O.el)==null?void 0:z.querySelectorAll(".beae-x-text a");H==null||H.forEach(I=>{let E=I==null?void 0:I.getAttribute("href");I&&O.mode.value!=="builder"&&(E!=null&&E.includes("#"))&&I.addEventListener("click",A=>{let D=document.querySelector(E+","+(E==null?void 0:E.replace("#",".")));if(D)return D.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),A.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-k7k30j4z: ', ex)
      };
    

      try {
        let argid = 'beae-vesouff0block-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-vesouff0',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-vesouff0');
        args.el = args.els[0];
        ((O) => { var z;let H=(z=O.el)==null?void 0:z.querySelectorAll(".beae-x-text a");H==null||H.forEach(I=>{let E=I==null?void 0:I.getAttribute("href");I&&O.mode.value!=="builder"&&(E!=null&&E.includes("#"))&&I.addEventListener("click",A=>{let D=document.querySelector(E+","+(E==null?void 0:E.replace("#",".")));if(D)return D.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),A.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-vesouff0: ', ex)
      };
    

      try {
        let argid = 'beae-kzv30je5block-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-kzv30je5',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-kzv30je5');
        args.el = args.els[0];
        ((O) => { var z;let H=(z=O.el)==null?void 0:z.querySelectorAll(".beae-x-text a");H==null||H.forEach(I=>{let E=I==null?void 0:I.getAttribute("href");I&&O.mode.value!=="builder"&&(E!=null&&E.includes("#"))&&I.addEventListener("click",A=>{let D=document.querySelector(E+","+(E==null?void 0:E.replace("#",".")));if(D)return D.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),A.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-kzv30je5: ', ex)
      };
    

      try {
        let argid = 'beae-s1wq4c2cblock-form',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-s1wq4c2c',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-s1wq4c2c');
        args.el = args.els[0];
        ((m) => { const h=window.location.href.indexOf("contact_posted=true")!==-1,u=m.el.querySelector("form");m.el.querySelector(".beae-btn-pr");const f=m.el.querySelectorAll("input","select","button","textarea","checkbox","radio"),b=m.el.querySelector(".btn-lightbox-form > button");!h&&m.mode.value!=="builder"&&(m.el.querySelector(".beae-form-success-message").style="display: none"),h&&m.afterSubmitting=="redirect"&&m.redirect&&(m.el.querySelector(".beae-form-success-message").style="display: block",window.location.href=m.redirect);const C=[];u&&u.addEventListener("submit",g=>{g.preventDefault();for(let v=0;v<f.length;v++)C.push({fieldKey:f[v].name,fieldType:f[v].type,fieldValue:f[v].value})}),b&&(b.onclick=()=>{const g=document.createElement("div");g.innerHTML=u.outerHTML||"",window.BeaePopupLibrary.createPopup(g,{layout:"center",layoutMobile:"bottom",width:"500px",id:m.id})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-s1wq4c2c: ', ex)
      };
    

      try {
        let argid = 'beae-2ywsc811section-slide-show',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-2ywsc811',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-2ywsc811');
        args.el = args.els[0];
        ((h) => { window.BeaeSlider&&!h.noRunJs&&window.BeaeSlider(h) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-2ywsc811: ', ex)
      };
    

      try {
        let argid = 'beae-j73f5lbcblock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-j73f5lbc',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-j73f5lbc');
        args.el = args.els[0];
        ((O) => { var z;let H=(z=O.el)==null?void 0:z.querySelectorAll(".beae-x-text a");H==null||H.forEach(I=>{let E=I==null?void 0:I.getAttribute("href");I&&O.mode.value!=="builder"&&(E!=null&&E.includes("#"))&&I.addEventListener("click",A=>{let D=document.querySelector(E+","+(E==null?void 0:E.replace("#",".")));if(D)return D.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),A.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-j73f5lbc: ', ex)
      };
    }; if (window.BEAEBASE) {js_2SNO48VL()} else {window.BEAEPAGEJS.push(js_2SNO48VL)} })(); 